const projectImg = [
  {
    thumb: require("../../assets/projects/17.jpg"),
    src: require("../../assets/projects/17.jpg"),
    caption: "Dąb Flamandzki, 15 x 150 x 600 – 1800, kl. Rustical",
    srcset: require("../../assets/projects/17.jpg"),
    description: "Dąb Flamandzki"
  },
  {
    thumb: require("../../assets/projects/1.jpg"),
    src: require("../../assets/projects/1.jpg"),
    caption:
      "Dąb Viggo Royal, Jodełka Klasyczna 15/6 x 130 x 600, kl. Rustcial",
    srcset: require("../../assets/projects/1.jpg"),
    description: "Dąb Viggo Royal"
  },

  {
    thumb: require("../../assets/projects/4.jpg"),
    src: require("../../assets/projects/4.jpg"),
    caption: "Dąb Antyk III, 15x150x600-1800",
    srcset: require("../../assets/projects/4.jpg"),
    description: "Dąb Antyk III"
  },
  {
    thumb: require("../../assets/projects/5t.jpg"),
    src: require("../../assets/projects/5.jpg"),
    caption: "Dąb Antyk III, 15x150x600-1800",
    srcset: require("../../assets/projects/5.jpg"),
    description: "Dąb Antyk III"
  },
  {
    thumb: require("../../assets/projects/6t.jpg"),
    src: require("../../assets/projects/6.jpg"),
    caption: "Dąb Emir, 15 x 150 x 600-1800, kl. Rustical",
    srcset: require("../../assets/projects/6.jpg"),
    description: "Dąb Emir"
  },
  {
    thumb: require("../../assets/projects/7t.jpg"),
    src: require("../../assets/projects/7.jpg"),
    caption: "Dąb Emir, 15 x 150 x 600-1800, kl. Rustical",
    srcset: require("../../assets/projects/7.jpg"),
    description: "Dąb Emir"
  },
  {
    thumb: require("../../assets/projects/8t.jpg"),
    src: require("../../assets/projects/8.jpg"),
    caption: "Dąb Antyk I 15x150x600-1800, kl. Rustical",
    srcset: require("../../assets/projects/8.jpg"),
    description: "Dąb Antyk I"
  },
  {
    thumb: require("../../assets/projects/9t.jpg"),
    src: require("../../assets/projects/9.jpg"),
    caption: "Dąb Antyk I 15x150x600-1800, kl. Rustical",
    srcset: require("../../assets/projects/9.jpg"),
    description: "Dąb Antyk I"
  },
  {
    thumb: require("../../assets/projects/10t.jpg"),
    src: require("../../assets/projects/10.jpg"),
    caption: "Dąb Milan, 15 x 150 x 600-1800, kl. Rustical",
    srcset: require("../../assets/projects/10.jpg"),
    description: "Dąb Milan"
  },
  {
    thumb: require("../../assets/projects/11t.jpg"),
    src: require("../../assets/projects/11.jpg"),
    caption: "Dąb Milan, 15 x 150 x 600-1800, kl. Rustical",
    srcset: require("../../assets/projects/11.jpg"),
    description: "Dąb Milan"
  },
  {
    thumb: require("../../assets/projects/12.jpg"),
    src: require("../../assets/projects/12.jpg"),
    caption: "Dąb Milan",
    srcset: require("../../assets/projects/12.jpg"),
    description: "Dąb Milan"
  },
  {
    thumb: require("../../assets/projects/13.jpg"),
    src: require("../../assets/projects/13.jpg"),
    caption: "Dąb Milan, 15 x 150 x 600-1800, kl. Rustical",
    srcset: require("../../assets/projects/13.jpg"),
    description: "Dąb Milan"
  },
  {
    thumb: require("../../assets/projects/14.jpg"),
    src: require("../../assets/projects/14.jpg"),
    caption:
      "Dąb Viggo Royal, Jodełka Klasyczna 15/6 x 130 x 600, kl. Rustcial",
    srcset: require("../../assets/projects/14.jpg"),
    description: "Dąb Viggo Royal"
  },
  {
    thumb: require("../../assets/projects/15t.jpg"),
    src: require("../../assets/projects/15.jpg"),
    caption: "Dąb Antyk I, 20 x 160 x 500-2000, kl. Rustical",
    srcset: require("../../assets/projects/15.jpg"),
    description: "Dąb Antyk I"
  },
  {
    thumb: require("../../assets/projects/16t.jpg"),
    src: require("../../assets/projects/16.jpg"),
    caption: "Dąb Antyk I, 20 x 160 x 500-2000, kl. Rustical",
    srcset: require("../../assets/projects/16.jpg"),
    description: "Dąb Antyk I"
  },
  {
    thumb: require("../../assets/projects/17t.jpg"),
    src: require("../../assets/projects/17.jpg"),
    caption: "Dąb Flamandzki, 15 x 150 x 600 – 1800, kl. Rustical",
    srcset: require("../../assets/projects/17.jpg"),
    description: "Dąb Flamandzki"
  },
  {
    thumb: require("../../assets/projects/18.jpg"),
    src: require("../../assets/projects/18.jpg"),
    caption: "Dąb Ostoja Spokoju, 15 x 170 x 600-1800, kl. Rustical",
    srcset: require("../../assets/projects/18.jpg"),
    description: "Dąb Ostoja Spokoju"
  },
  {
    thumb: require("../../assets/projects/19.jpg"),
    src: require("../../assets/projects/19.jpg"),
    caption: "Dąb Ostoja Spokoju, 15 x 170 x 600-1800, kl. Rustical",
    srcset: require("../../assets/projects/19.jpg"),
    description: "Dąb Ostoja Spokoju"
  },
  {
    thumb: require("../../assets/projects/20.jpg"),
    src: require("../../assets/projects/20.jpg"),
    caption: "Dąb Ostoja Spokoju, 15 x 170 x 600-1800, kl. Rustical",
    srcset: require("../../assets/projects/20.jpg"),
    description: "Dąb Ostoja Spokoju"
  },
  {
    thumb: require("../../assets/projects/21.jpg"),
    src: require("../../assets/projects/21.jpg"),
    caption: "Dąb Ostoja Spokoju, 15 x 170 x 600-1800, kl. Rustical",
    srcset: require("../../assets/projects/21.jpg"),
    description: "Dąb Ostoja Spokoju"
  },
  {
    thumb: require("../../assets/projects/22.jpg"),
    src: require("../../assets/projects/22.jpg"),
    caption: "Dąb Ostoja Spokoju, 15 x 170 x 600-1800, kl. Rustical",
    srcset: require("../../assets/projects/22.jpg"),
    description: "Dąb Ostoja Spokoju"
  },
  {
    thumb: require("../../assets/projects/23t.jpg"),
    src: require("../../assets/projects/23.jpg"),
    caption: "Dąb Nordycki, 15 x 150 x 600 – 1800, kl. Standard",
    srcset: require("../../assets/projects/23.jpg"),
    description: "Dąb Nordycki"
  },
  {
    thumb: require("../../assets/projects/24t.jpg"),
    src: require("../../assets/projects/24.jpg"),
    caption: "Dąb Mars, 15 x 150 x 600-1800, kl. Rustical",
    srcset: require("../../assets/projects/24.jpg"),
    description: "Dąb Mars"
  },
  {
    thumb: require("../../assets/projects/25t.jpg"),
    src: require("../../assets/projects/25.jpg"),
    caption: "Dąb Milan 15x130x600-1800, kl. Rustical",
    srcset: require("../../assets/projects/25.jpg"),
    description: "Dąb Milan"
  },
  {
    thumb: require("../../assets/projects/26t.jpg"),
    src: require("../../assets/projects/26.jpg"),
    caption: "Dąb Milan 15x130x600-1800, kl. Rustical",
    srcset: require("../../assets/projects/26.jpg"),
    description: "Dąb Milan"
  },
  {
    thumb: require("../../assets/projects/27t.jpg"),
    src: require("../../assets/projects/27.jpg"),
    caption: "Dąb Antyk I 15x150x600-1800, kl. Rustical",
    srcset: require("../../assets/projects/27.jpg"),
    description: "Dąb Antyk I"
  },
  {
    thumb: require("../../assets/projects/28t.jpg"),
    src: require("../../assets/projects/28.jpg"),
    caption: "Dąb Antyk I 15x150x600-1800, kl. Rustical",
    srcset: require("../../assets/projects/28.jpg"),
    description: "Dąb Antyk I"
  },
  {
    thumb: require("../../assets/projects/29.jpg"),
    src: require("../../assets/projects/29.jpg"),
    caption: "Dąb Bert 15x130x600-1800, kl. Rustical",
    srcset: require("../../assets/projects/29.jpg"),
    description: "Dąb Bert"
  },
  {
    thumb: require("../../assets/projects/30.jpg"),
    src: require("../../assets/projects/30.jpg"),
    caption: "Dąb Bert 15x130x600-1800, kl. Rustical",
    srcset: require("../../assets/projects/30.jpg"),
    description: "Dąb Bert"
  },
  {
    thumb: require("../../assets/projects/31t.jpg"),
    src: require("../../assets/projects/31.jpg"),
    caption: "Dąb Sycylia 15x170x600-1800, kl. Rustical",
    srcset: require("../../assets/projects/31.jpg"),
    description: "Dąb Sycylia"
  },
  {
    thumb: require("../../assets/projects/32t.jpg"),
    src: require("../../assets/projects/32.jpg"),
    caption: "Dąb Sycylia 15x170x600-1800, kl. Rustical",
    srcset: require("../../assets/projects/32.jpg"),
    description: "Dąb Sycylia"
  },
  {
    thumb: require("../../assets/projects/33.jpg"),
    src: require("../../assets/projects/33.jpg"),
    caption: "Antyk I 15 x 170 x mix, kl. Rustical 1",
    srcset: require("../../assets/projects/33.jpg"),
    description: "Antyk I"
  },
  {
    thumb: require("../../assets/projects/34t.jpg"),
    src: require("../../assets/projects/34.jpg"),
    caption: "Antyk I 15 x 170 x mix, kl. Rustical",
    srcset: require("../../assets/projects/34.jpg"),
    description: "Antyk I"
  },
  {
    thumb: require("../../assets/projects/35t.jpg"),
    src: require("../../assets/projects/35.jpg"),
    caption: "Dąb Bert 13 x 150, kl .Rustical",
    srcset: require("../../assets/projects/35.jpg"),
    description: "Dąb Bert"
  },
  {
    thumb: require("../../assets/projects/36t.jpg"),
    src: require("../../assets/projects/36.jpg"),
    caption: "Dąb Donan SHOKO, 13 x 130 x 1800, kl. Rustical 2",
    srcset: require("../../assets/projects/36.jpg"),
    description: "Dąb Donan SHOKO"
  },
  {
    thumb: require("../../assets/projects/37t.jpg"),
    src: require("../../assets/projects/37.jpg"),
    caption: "Dąb Donan SHOKO, 13 x 130 x 1800, kl. Rustical 3",
    srcset: require("../../assets/projects/37.jpg"),
    description: "Dąb Donan SHOKO"
  },
  {
    thumb: require("../../assets/projects/38t.jpg"),
    src: require("../../assets/projects/38.jpg"),
    caption: "Dąb Donan SHOKO, 13 x 130 x 1800, kl. Rustical",
    srcset: require("../../assets/projects/38.jpg"),
    description: "Dąb Donan SHOKO"
  },
  {
    thumb: require("../../assets/projects/39.jpg"),
    src: require("../../assets/projects/39.jpg"),
    caption: "Dąb Dworski, 15 x 150 x mix, kl. Rustical",
    srcset: require("../../assets/projects/39.jpg"),
    description: "Dąb Dworski"
  },
  {
    thumb: require("../../assets/projects/40t.jpg"),
    src: require("../../assets/projects/40.jpg"),
    caption: "Dąb Milan 13 x 150 x mix, kl. Rustical",
    srcset: require("../../assets/projects/40.jpg"),
    description: "Dąb Milan"
  },
  {
    thumb: require("../../assets/projects/41t.jpg"),
    src: require("../../assets/projects/41.jpg"),
    caption: "Flamandzki 13 x 150 x mix, kl. Rustical",
    srcset: require("../../assets/projects/41.jpg"),
    description: "Flamandzki"
  },
  {
    thumb: require("../../assets/projects/42.jpg"),
    src: require("../../assets/projects/42.jpg"),
    caption: "Flamandzki 13 x 150 x mix, kl. Rustical",
    srcset: require("../../assets/projects/42.jpg"),
    description: "Flamandzki"
  },
  {
    thumb: require("../../assets/projects/43t.jpg"),
    src: require("../../assets/projects/43.jpg"),
    caption: "Luminos Shoko 13 x 130 x 1800, kl. Rustical",
    srcset: require("../../assets/projects/43.jpg"),
    description: "Luminos Shoko"
  },
  {
    thumb: require("../../assets/projects/44t.jpg"),
    src: require("../../assets/projects/44.jpg"),
    caption: "Luminos Shoko 13 x 130 x 1800, kl. Rustical",
    srcset: require("../../assets/projects/44.jpg"),
    description: "Luminos Shoko"
  },
  {
    thumb: require("../../assets/projects/45.jpg"),
    src: require("../../assets/projects/45.jpg"),
    caption: "Luminos Shoko 13 x 130 x 1800, kl. Rustical",
    srcset: require("../../assets/projects/45.jpg"),
    description: "Luminos Shoko"
  },
  {
    thumb: require("../../assets/projects/46.jpg"),
    src: require("../../assets/projects/46.jpg"),
    caption: "Luminos Shoko 13 x 130 x 1800, kl. Rustical",
    srcset: require("../../assets/projects/46.jpg"),
    description: "Luminos Shoko"
  },
  {
    thumb: require("../../assets/projects/47.jpg"),
    src: require("../../assets/projects/47.jpg"),
    caption: "Zimowy Poranek, 13 x 150 x mix, kl. Standard",
    srcset: require("../../assets/projects/47.jpg"),
    description: "Zimowy Poranek"
  }
];
const projectImages = projectImg.reverse();
export default projectImages;
